import { render } from "./WhatsappTemplateCreateOverlay.vue?vue&type=template&id=aa25dad2&scoped=true&ts=true"
import script from "./WhatsappTemplateCreateOverlay.vue?vue&type=script&lang=ts"
export * from "./WhatsappTemplateCreateOverlay.vue?vue&type=script&lang=ts"

import "./WhatsappTemplateCreateOverlay.vue?vue&type=style&index=0&id=aa25dad2&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa25dad2"]])

export default __exports__